// src/components/Footer.jsx
import { Box, Typography } from "@mui/material";
import { Link } from "@mui/material";



export default function Footer() {
    return (
        <Box
            className="app-footer"
            sx={{ textAlign: "center", py: 3, mt: 4, bgcolor: "primary.main", color: "white" }}
        >
            <Typography variant="body2">
                © {new Date().getFullYear()} 321‑TIMING.ch —
                <Link href="/mentions-legales" style={{ color: "white", marginLeft: 4 }}>
                    Tous droits réservés
                </Link>
            </Typography>

        </Box>
    );
}